import React from 'react';

function Previous() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M24 24L7 12 24 0v24zM4 0v24H0V0h4z" />
    </svg>
  );
  /* eslint-enable */
}

export default Previous;



// WEBPACK FOOTER //
// ./src/common/icons/Previous.js